$mol_link_iconed $mol_link
	sub /
		<= Icon $mol_image
			uri <= icon \
			title \
	content /
		<= title <= uri
	host \
